export default class RnFormError extends Error {

    constructor(message) {
        super(message);
        this.name = this.constructor.name;

        this.disableDefaultHandling = true;
    }
}
